<script setup lang="ts">
import { ContactButtonGroup } from '@/features/profile';
import { useVModel } from '@vueuse/core';
import { type FragmentType } from '@/gql';
import { type contactFieldsFragment } from '@/features/users';

const props = defineProps<{
  modelValue?: boolean;
  fields: FragmentType<typeof contactFieldsFragment>;
}>();
defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void;
}>();

const isVisible = useVModel(props, 'modelValue');
</script>

<template>
  <AppModal v-model="isVisible" title="Контакты">
    <ContactButtonGroup click-behavior="link" :fields="props.fields" />
  </AppModal>
</template>
